import React from "react";
import "./Pricing.css";

const monthlyFeatures = [
  "Codie – AI Coding Assistant",
  "Access to Deep Research",
  "5+ Starter Kits",
  "5,000 Monthly Credits",
  "Create All Dev Docs: PRDs, Tech stacks, etc.",
  "Refine Project Ideas with AI",
  "Work With All Advanced Coding Tools",
  "Access 40+ Ready-to-Use Templates",
  "Access to 01-preview Model & Claude",
  "Complete 15 Projects per Month",
];

const yearlyFeatures = [
  "Exclusive discounts and free plans on AI tools",
  "Codie – AI Coding Assistant",
  "Access to Deep Research",
  "5+ Starter Kits",
  "30-minute one-on-one call",
  "6,000 Monthly Credits",
  "Complete 18 Projects per month",
  "Priority Support",
  "Early Access to New Features",
  "Create All Dev Docs: PRDs, Tech stacks, etc.",
  "Refine Project Ideas with AI",
  "Work With All Advanced Coding Tools",
  "Access 40+ Ready-to-Use Templates",
  "Access to 01-preview Model & Claude",
  "Get Dedicated Support and Community",
];

function Pricing() {
  return (
    <section className="pricing" id="pricing">
      <div className="pricing__badge">Pricing</div>
      <h2 className="pricing__headline">One plan. One decision.</h2>
      <p className="pricing__subtitle">Most users save more in a single auction than they'll spend in a decade of access.</p>
      <div className="pricing__cards">
        <div className="pricing-card pricing-card--annual">
          <div className="pricing-card__price-row">
            <span className="pricing-card__currency">$</span>
            <span className="pricing-card__price">396</span>
            <span className="pricing-card__period">/year</span>
          </div>
          <p className="pricing-card__tagline">Twelve months of full access.</p>

          <div className="pricing-card__callout">
            Porsche buyers and sellers regularly leave <strong>thousands of dollars</strong> on the table without the right data. Bidder iQ costs <strong>$396/year</strong> — one better-informed bid pays for years of access.
          </div>

          <ul className="pricing-card__feature-grid">
            <li><span className="pricing-card__check">✓</span> Bidder iQ Advanced Analytics</li>
            <li><span className="pricing-card__check">✓</span> Bidder iQ Chrome Extension</li>
            <li><span className="pricing-card__check">✓</span> Price Guide with real comps</li>
            <li><span className="pricing-card__check">✓</span> Market trend analysis</li>
            <li><span className="pricing-card__check">✓</span> Save your favorite searches</li>
            <li><span className="pricing-card__check">✓</span> BaT, PCARMARKET &amp; Cars &amp; Bids data</li>
            <li><span className="pricing-card__check">✓</span> Sold &amp; unsold auction results</li>
          </ul>

          <a href="/sign-up" className="pricing-card__main-cta">Stop Leaving Money on the Table — Get Annual Access</a>

          <ul className="pricing-card__benefits">
            <li><span className="pricing-card__check">✓</span> Instant access</li>
            <li><span className="pricing-card__check">✓</span> Cancel anytime</li>
            <li><span className="pricing-card__check">✓</span> Built on 15,000+ real results</li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default Pricing;
